// @flow

import React from 'react';
import _ from 'lodash';

import { SimpleTable } from '@zapier/common-components';

import type { PlanTier } from '@zapier/design-system-revenue';

type MeteredTiersTableProps = {
  data: Array<PlanTier>,
};

const formatTier = (numTasks, tierIndex) =>
  numTasks === -1
    ? 'Any Additional'
    : `${tierIndex === 0 ? 'First' : 'Next'} ${numTasks.toLocaleString(
        'en-US'
      )}`;

// Price is fraction of a cent. Should be at most 4
// digits after decimal and we'd like them all to be
// even, so pad them with 0.
const formatPrice = price =>
  price === 0 ? 'Included' : _.padEnd(`$${price / 100}`, 7, '0');

const formatTiers = (data = []) => {
  return [
    ['Tasks', 'Price Per Task'],
    ...data.map((tier, i) => [
      formatTier(tier.numTasks, i),
      formatPrice(tier.pricePerTask),
    ]),
  ];
};

const MeteredTiersTable = ({ data }: MeteredTiersTableProps) => (
  <SimpleTable data={formatTiers(data)} />
);

export default MeteredTiersTable;
